<template>
    <div class="verticalSliderContainer">
        <div class="interactionHelp">Slide up or down to answer</div>
        <div class="topTitle">
            {{values.topTitle}}
        </div>
        <div class="verticalSlider">
            <div class="stick"></div>
            <div class="tick"></div>
            <div class="stick"></div>
            <div class="tick"></div>
            <div class="stick"></div>
            <div class="tick"></div>
            <div class="stick"></div>
            <vue-draggable-resizable id="dragger" :w="126" :h="126" :y="262" v-on:dragging="onDrag" :parent="true" :resizable="false" >
                <div class="grabber" ><div class="dot"></div></div>
            </vue-draggable-resizable>
        </div>
        <div class="bottomTitle">
            {{values.bottomTitle}}
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" class="definitions-hide" style="display:none">
            <defs>
                <filter id="blurr">
                <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur"></feGaussianBlur>
                <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" result="goo"></feColorMatrix>
                <feBlend in="SourceGraphic" in2="goo"></feBlend>
                </filter>
            </defs>
        </svg>
    </div>
</template>

<script>
import $ from 'jquery'
import VueDraggableResizable from 'vue-draggable-resizable'

export default {
    name: 'Intro',
    props: ['value', 'content'],
    mixins: [],
    data() {
        return {
            trackHeight: 524,
            values: {
                topTitle: this.content[0],
                bottomTitle: this.content[1], 
                position: null,
            }
        }
    },

    components: {
        VueDraggableResizable
    },
    ready() {
        
    },
    methods: {
        updateSelection: function () {
            this.$emit('input', this.values.position);
        },
        onDrag: function (x, y) {
            let travelDist = this.trackHeight;
            let trueY = (travelDist-y)/travelDist;
            if (trueY < 0) trueY = 0;
            else if (trueY > 1) trueY = 1;
            trueY = Math.round((trueY*4)-2)
            if (trueY == 0) trueY = 0;

            if (this.values.position != trueY) {
                this.values.position = trueY;
                this.$sound('drip', parseInt(trueY+2))
            }
        },
        snapHandle() {
            this.updateSelection()
            let invert = 1-((this.values.position+2)/4);
            let destination = Math.abs(invert*this.trackHeight)
            let start = $(".draggable").css('top').split('px')[0]
            var obj = { charged: start };
            var JSobject = this.$anime({
                targets: obj,
                charged: destination,
                duration: 1000,
                elasticity: 750,
                update: function() {
                    $(".draggable").css('top', obj.charged)
                }
            });
            let pitch = parseInt(this.values.position+2)
            this.$sound('drop', pitch)
        }
    },

    computed: {
    },

    watch: {
    },

    created() {
    },

    destroyed() {
    },

    mounted() {
        this.$nextTick(() => {
            
            $(".grabber").on('touchend mouseup', (e) => {
                this.snapHandle()
            })
            let mid = 262
            let variance = 40
            $(".draggable").css('top', mid)
            if ($("#formContainer.Introduction").length > 0) {
                let obj = { charged: mid };
                let JSobject = this.$anime({
                    targets: obj,
                    charged: mid+variance,
                    duration: 1000,
                    delay: 500,
                    elasticity: 0,
                    easing: 'easeInExpo',
                    update: function() {
                        $(".draggable").css('top', obj.charged)
                    },
                    complete: (anim) => {
                        this.$sound('drop')
                        let JSobject1 = this.$anime({
                            targets: obj,
                            charged: mid-variance,
                            duration: 250,
                            easing: 'easeInOutSine',
                            elasticity: 0,
                            update: function() {
                                $(".draggable").css('top', obj.charged)
                            },
                            complete: (anim) => {
                                let JSobject2 = this.$anime({
                                    targets: obj,
                                    charged: mid,
                                    duration: 1250,
                                    elasticity: 500,
                                    update: function() {
                                        $(".draggable").css('top', obj.charged)
                                    }
                                });
                            }
                        });
                    }
                });
            }
        })
    }

}
</script>

<style lang="scss">
@import "../styles/variables.scss";

.verticalSliderContainer {
    position: absolute;
    left: 0;
    top: 33vh;
    width: 100%;
    height: 67vh;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    filter:url('#blurr');
    .topTitle, .bottomTitle {
        width: 66vw;
        height: 17vw;
        background-color: $color-darkCream;
        font-size: 3.5vw;
        font-weight: 300;
        border-radius: 1.5vw;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        border: solid 4vw transparent;
    }
    .verticalSlider {
        position: relative;
        height: 26vh;
        width: .5vw;
        margin: -2.5vh 0;
        padding: 3.25vh 0;
        .bg {
            float: left;
            background-color: $color-lightWhite;
            width: 100%;
            height: 100%;
        }
        .stick {
            background-color:$color-darkCream;
            opacity: .5;
            width: 100%;
            height: 5vh;
        }
        .tick {
            background: $color-darkerCream;
            width: 1.5vw;
            height: 1.5vw;
            border-radius: 2vw;
            margin: .55vh 0;
            margin-left: -.5vw;
        }
        .grabber {
            position: absolute;
            top: 0;
            left: -4.5vw;
            background: $color-darkCream;
            width: 4vw;
            height: 4vw;
            border-radius: 5vw;
            padding: 2.75vw;
            .dot {
                width: 4vw;
                height: 4vw;
                border-radius: 2.5vw;
                background: $color-dark;
            }
        }
    }
    .interactionHelp {
        color: $color-dark;
        font-size: 3.5vw;
        opacity: .35;
        margin-bottom: 5vw;
    }
}
#formContainer.Mental {
    .interactionHelp {
        color: $color-white;
        opacity: .35;
    }
}

#surveyContainer .VerticalSlider input.sv_next_btn {
    position: absolute;
    bottom: 8vw;
    left: 50vw;
    margin-left: -24vw;
}

</style>